/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Notes_Notes_Complete_LabelInputs */



/**
* | output |
* | --- |
* | "Notes Complete" |
*
* @param {Event_Notes_Notes_Complete_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_notes_notes_complete_label = /** @type {((inputs?: Event_Notes_Notes_Complete_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Notes_Notes_Complete_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Notes completees")
	if (locale === "de") return /** @type {LocalizedString} */ ("Notizen vollständig")
	if (locale === "it") return /** @type {LocalizedString} */ ("Note complete")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Примечания завершены")
	if (locale === "es") return /** @type {LocalizedString} */ ("Notas completas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("笔记已完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メモ完了")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नोट्स पूरे")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Notas concluídas")
	return /** @type {LocalizedString} */ ("Notes Complete")
});